export enum EmailSidebarType {
  BUSINESS_EVENTS = 'Business Events',
}

export enum EmailSidebarTitle {
  BUSINESS_EVENTS = 'Client Signals',
}
